import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {FileRename} from "./types/file-rename";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatDividerModule} from "@angular/material/divider";
import {QuillEditorComponent} from "ngx-quill";
import {fadeInUp400ms} from "../../../../@vex/animations/fade-in-up.animation";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from '@angular/material/core';
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {File} from "../../../file-manager/types/file";
import {FileManagerService} from "../../../file-manager/file-manager.service";
import {TranslateModule} from "@ngx-translate/core";

interface LanguageConfig {
  code: string;
  name: string;
  flag: string;
}

@Component({
    animations: [
        fadeInUp400ms,
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatNativeDateModule,
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
        MatDialogModule,
        MatDividerModule,
        QuillEditorComponent,
        MatDatepickerModule,
        MatButtonModule,
        MatSelectModule,
        TranslateModule,
    ],
    selector: 'vex-blog-category-create-update',
    styleUrls: [
        './rename-file.component.scss',
    ],
    templateUrl: './rename-file.component.html'
})
export class RenameFileComponent implements OnInit {

  public file: File;
  public form: FormGroup;

  public readonly languages: LanguageConfig[] = [
    { code: 'de', name: 'Deutsch', flag: 'flag:germany' },
    { code: 'en', name: 'English', flag: 'flag:united-kingdom' },
  ];

  public constructor(
    private dialogRef: MatDialogRef<RenameFileComponent>,
    private fileManagerService: FileManagerService,
    @Inject(MAT_DIALOG_DATA) public data: FileRename
  ) {
    this.form = this.createForm();
  }

  ngOnInit(): void {
    if (this.data.file) {
      this.file = this.data.file;
      this.form = this.createForm(this.file);
    }
  }

  private createForm(file?: File): FormGroup {
    const controls: Record<string, FormControl> = {};

    for (const lang of this.languages) {
      const existingLabel = file?.labels?.[lang.code] ?? '';
      controls[`label_${lang.code}`] = new FormControl(existingLabel);
    }

    return new FormGroup(controls);
  }

  public save(): void {
    const labels: Record<string, string | null> = {};

    for (const lang of this.languages) {
      const value = this.form.getRawValue()[`label_${lang.code}`];
      labels[lang.code] = value || null;
    }

    this.fileManagerService.saveFileLabels(this.data.file.id, labels).subscribe(
      file => {
        this.dialogRef.close(file);
      }
    )
  }
}
